import { render } from "./CoverController.vue?vue&type=template&id=3a8151c6&scoped=true"
import script from "./CoverController.vue?vue&type=script&lang=ts"
export * from "./CoverController.vue?vue&type=script&lang=ts"

import "./CoverController.vue?vue&type=style&index=0&id=3a8151c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a8151c6"

export default script